import cn from 'classnames'
import type { ReactNode } from 'react'

import styles from './FloatingSupportMenu.module.scss'

interface LoggedInSupportFabProps {
  onClick: () => void
  triggerIcon: ReactNode
  triggerLabel?: string
}

/**
 * Single-purpose fab for the logged-in state: click calls `onClick` directly.
 * No dropdown — matches the pre-existing `SupportFab` behavior.
 */
function LoggedInSupportFab(props: LoggedInSupportFabProps) {
  const { onClick, triggerIcon, triggerLabel } = props

  return (
    // Carries both classes: `floating-support-menu` positions/anchors the widget (fixed,
    // bottom-right) — in the logged-out state that's the wrapper div's job, but here there's
    // no separate wrapper, so this single button plays that role itself.
    <button
      type='button'
      className={cn(styles['floating-support-menu'], styles['floating-support-menu-trigger'])}
      onClick={onClick}
      aria-label={triggerLabel}
    >
      {triggerIcon}
    </button>
  )
}

export default LoggedInSupportFab
